import { render } from "./NumberConverter.vue?vue&type=template&id=f22b575a"
import script from "./NumberConverter.vue?vue&type=script&lang=js"
export * from "./NumberConverter.vue?vue&type=script&lang=js"

import "./NumberConverter.vue?vue&type=style&index=0&id=f22b575a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__